import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;

  svg {
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 34px;
    width: 132px;
    height: 132px;
  }
  h4 {
    font: normal normal bold 20px/24px Inter;
    color: ${props => props.theme.colors.color2d3139};
    text-align: center;
    margin-bottom: 16px;
  }
  span {
    font: normal normal normal 14px/17px Inter;
    color: ${props => props.theme.colors.color6b7786};
    text-align: center;
    margin-bottom: 34px;
  }
`
export const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  button {
    width: 116px;
    height: 40px;
  }
`
